import { gql } from '@apollo/client';

export const UPDATE_ORDER_REPRINT_CONFIRM = gql`
    mutation UpdateOrderReprintConfirm(
        $id: Long!
        $reprintTrackingNumber: String!
    ) {
        updateOrderReprintConfirm(
            id: $id
            reprintTrackingNumber: $reprintTrackingNumber
        )
    }
`;

export interface UpdateOrderReprintConfirmVariables {
    id: number;
    reprintTrackingNumber: string;
}

export interface UpdateOrderReprintConfirmResponse {
    updateOrderReprintConfirm: boolean;
}
